import helpers from './helpers';
/**
 * Parse a formula and detect all dependencies (fields or context values)
 * @param {string} value
 * @param {import("../logic/types").EcrionFormState} state
 * @returns {Array<import("./types").FormulaToken>}
 */

var parse = function parse(value, state) {
  if (!value || !value.match) return [];
  var matches = value.match(/{[^}]+}?}/g);
  if (!matches || !matches.length) return [];
  return matches.reduce(function (dependencies, match) {
    return dependencies.concat(parseTokenString(match, state));
  }, []);
};
/**
 * Parse a formula and detect all dependencies (fields or context values)
 * @param {string} tokenStr
 * @param {import("../logic/types").EcrionFormState} state
 * @returns {Array<import("./types").FormulaToken>}
 */


var parseTokenString = function parseTokenString(tokenStr, state) {
  if (tokenStr.startsWith('{{FORMULA')) return parseFormulaToken(state.formulas && state.formulas[tokenStr]);
  if (tokenStr.startsWith('{{FIELD:')) return [{
    type: 'field',
    id: helpers.extractFieldId(tokenStr)
  }];
  return [{
    type: 'context',
    id: helpers.extractContextId(tokenStr)
  }];
};
/**
 * @param {import('./types').EcrionFormFormula} formula
 * @param {import("../logic/types").EcrionFormState} state
 * @returns {Array<import("./types").FormulaToken>}
 */


var parseFormulaToken = function parseFormulaToken(formula, state) {
  if (!formula || !formula.id) return [];
  if (formula.id.toLowerCase() === 'field') return parseTokenString(formula.value, state);
  if (formula.id.toLowerCase() === 'context') return parseTokenString(formula.value, state);
  if (formula.id.toLowerCase() === 'value') return []; // static value

  return formula.value.reduce(function (dependencies, formulaToken) {
    return dependencies.concat(parseFormulaToken(formulaToken, state));
  }, []);
};

export default parse;